var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Lookup',{attrs:{"lookup_type_id":21,"title":'Employment Status'}})
}
var staticRenderFns = []

export { render, staticRenderFns }